import React, { Component, useState, useEffect, useContext } from "react";
import '../../styles.css';
import { alert_error, alert_success } from '../../AppContext';
import AdSense from 'react-adsense';
import { Link, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { Cookies } from '../../index.js';
import { Helmet } from "react-helmet";
import StatusBadge from "../../js/buttonstatus.jsx";
import { ClipLoader, PulseLoader } from 'react-spinners';
import axios from "axios";
import queryString from 'query-string';
import Banner from '../../Banner';
import Bannerprofile from '../../shop/ads/Bannerprofile.jsx';
function Nhatkyorders(props) {
    const [nutxuly, setnutxuly] = useState(0);
    const [hiendanhsach, sethiendanhsach] = useState(true);
    // Lấy đường dẫn hiện tại
    const currentPath = window.location.pathname;

    // Tách lấy phần cuối cùng của đường dẫn
    const parts = currentPath.split('/');
    const duongdan = parts[parts.length - 1];
    const [buttonTextjop, setbuttonTextjop] = useState("Xác nhận");
    const [timkiem, settimkiem] = useState(false);
    const [inputlienket, setinputlienket] = useState('');
    const [chedo, setchedo] = useState('');
    const options = [
        { text: 'Chọn 1 chế độ tìm kiếm', value: '' },
        { text: 'Tìm theo liên kết', value: 'getlienket' },
        { text: 'Tìm theo id', value: 'getid' }
    ];

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    function handleToggle(isOn) {
        if (isOn) {
            settimkiem(true);
        } else {
            settimkiem(false);
            sethiendanhsach(true);
        }
    }

    function testFunction(response) {
        if (response.data != '') {
            setnutxuly(0);
            setbuttonTextjop('xác nhận');
            setdulieudonhang(response.data);
            setbuttonloadlist(false);
            settimkiem(false);
            sethiendanhsach(false);
        }
        else {
            setnutxuly(0);
            setbuttonTextjop('xác nhận');
            alert_error('Không tìm thấy dữ liệu');
        }
    };
    function handleSubmit(event) {
        const myCookieValue = Cookies.get('apikey');
        event.preventDefault();
        setnutxuly(1);
        setbuttonTextjop('Please wait a moment 😊');
        if (!inputlienket || !chedo) {
            alert('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setbuttonTextjop('điền đủ thông tin');
            return
        }
        else {

            axios.get(
                'https://hust.media/getservice/' + duongdan + '.php?' + chedo + '=' + inputlienket + '&apikey=' + myCookieValue)
                .then(response => (testFunction(response)))
                .catch(error => console.log(error))

        }

    }
    const [buttonloadlist, setbuttonloadlist] = useState(true);
    const totalPages = 5; // tổng số trang
    const values = queryString.parse(window.location.search);
    const currentPagephu = values.listtrang
    const [currentPage, setcurrentPage] = useState(1);
    // tạo một mảng chứa các số trang từ 1 đến totalPages
    const [pageNumbers, setpageNumbers] = useState(Array.from({ length: totalPages }, (_, i) => i + 1));

    const [dulieudonhang, setdulieudonhang] = useState([
        {
            id: 1,
            start_count: 100,
            remains: 50,
            service_name: "Đang tải danh sách vui lòng đợi",
            url: "Đang tải danh sách vui lòng đợi",
            amount: 10,
            money: 100,
            note: "Note 1",
            updatedate: "2023-04-05",
        }
        // Thêm dữ liệu vào đây
    ]);
    const laynhatky = async () => {
        const myCookieValue = Cookies.get('apikey');
        const values = queryString.parse(window.location.search);
        const listtrang = values.listtrang || 1;

        setcurrentPage(values.listtrang);


        try {
            const response = await axios.get('https://hust.media/jop/auto/history.php?apikey=' + myCookieValue);
            if (response.data != '') {

                setdulieudonhang(response.data);
                setbuttonloadlist(false);
            }


        } catch (error) {

        }
    };

    const location = useLocation();
    useEffect(() => {
        setbuttonloadlist(true);
        // Xử lý sự kiện khi location thay đổi, ví dụ:
        console.log('Đã thay đổi đường dẫn:', location.pathname);
        laynhatky();
    }, [location]);

    // render component

    return (
        <>
            <div className="mb-2 mt-1 max-w-md mx-auto">
                <Bannerprofile />
            </div>
            {/* {duongdan} */}

            <div className="container-fluid mt--9">

                <div className="row">

                    <div className="col-xl-12 order-xl-2 mb-5 mb-xl-0">
                        {dulieudonhang === 'empty' && !buttonloadlist ? (

                            <>
                                <div className="table-responsive overflow-x-hidden">
                                    <div className="text-center text-2xl mt-3">
                                        📦 Danh sách đơn hàng trống rỗng, chưa có thông tin nào 📭
                                    </div>
                                </div>
                            </>
                        ) : (
                            buttonloadlist ? (
                                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                                    <ClipLoader color="#fff" size={150} />
                                </div>
                            ) : (<div className="table-responsive overflow-x-hidden">
                                <table className="table align-middle table-flush table-sm table-bordered">
                                    <thead className="thead-light" >
                                        <tr>
                                            <th className="text-lowercase text-center" style={{ width: "10%" }} scope="row">
                                                mã đơn hàng
                                            </th>
                                            <th className="text-center" style={{ width: "10%" }} scope="row">
                                                DỊCH VỤ
                                            </th>
                                            <>  <th className="text-lowercase text-center" style={{ width: "31%" }} scope="col">
                                                link
                                            </th></>
                                            <th className="text-center" style={{ width: "10%" }} scope="row">
                                                Mô tả
                                            </th>
                                            <th className="text-center" style={{ width: "10%" }} scope="col">
                                                THỜI GIAN
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dulieudonhang.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <p onClick={() => saochep(item.id)} className="text-sm">{item.id}</p>
                                                    <div
                                                        className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                        dangerouslySetInnerHTML={{ __html: item.note }}
                                                    ></div>
                                                </td>
                                                <td className="text-center">
                                                    <span className="inline-block text-sm font-bold text-white  px-1 py-1 
                            break-all  bg-danger  rounded-pill text-wrap">
                                                        <b className="text-white">{item.service_name}</b>
                                                    </span>
                                                    {item.add_user &&
                                                        <>
                                                            <div
                                                                className="text-xs text-lowercase text-black mt-2 rounded-pill text-wrap"
                                                            >
                                                                Tài khoản thêm
                                                            </div>
                                                            <div
                                                                className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                            >
                                                                {item.add_user}
                                                            </div>
                                                        </>
                                                    }
                                                </td>
                                                {

                                                    <td className="text-center">
                                                        <div style={{ width: "100%" }} className="inline-block bg-blue-500 font-bold text-white px-2 py-1 rounded-full  break-all text-wrap">
                                                            <div className="text-base">
                                                                {item.url}
                                                            </div>
                                                        </div>
                                                    </td>

                                                }
                                                <td className="text-center">
                                                    <b style={{ color: "blue" }}>{item.amount}</b>
                                                    <br />
                                                    <b style={{ color: "red" }}>{item.money}</b> Coins
                                                    <br />
                                                    <div style={{ width: "100%" }} className="text-lowercase text-wrap">
                                                        <StatusBadge status={item.status}/>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div style={{ width: "100%" }} className="text-lowercase text-wrap">
                                                        <div
                                                            className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                        >
                                                            Khởi tạo
                                                        </div>
                                                        <br />
                                                        {item.createdate}
                                                        <br />
                                                        <div
                                                            className="text-xs text-lowercase text-black badge-light badge rounded-pill text-wrap"
                                                        >
                                                            ngày hết hạn
                                                        </div>
                                                        <br />
                                                        {item.updatedate}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>)

                        )
                        }

                    </div>
                </div></div>
        </>
    );
};

export default Nhatkyorders;
